import styled from 'styled-components/macro';

const Svg = styled.svg`
  display: block;
  margin: 0 auto;
  max-width: 100%;
`;
const Anchor = styled.a`
  color: inherit;
`;

export const Logo = () => (
  <Anchor href="https://www.votvot.tv/">
    <Svg
      width="790"
      viewBox="0 0 790 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.9669 79.4631L41.5124 0H0.469391L42.0717 125H83.8621L125.469 0H84.4213L62.9669 79.4631ZM169.894 9.8317e-06L133.282 36.6122V88.3878L169.894 125H221.67L258.282 88.3878V36.6122L221.67 9.8317e-06H169.894ZM219.329 86.047H172.23V38.9481H219.329V86.047ZM308.282 34.375H266.094L266.095 9.8317e-06H391.094L391.094 34.375H348.907L348.799 125H308.282L308.282 34.375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M461.402 79.4631L439.947 0H398.904L440.507 125H482.297L523.904 0H482.856L461.402 79.4631ZM568.329 0L531.717 36.6121V88.3878L568.329 125H620.105L656.717 88.3878V36.6121L620.105 0H568.329ZM617.764 86.047H570.665V38.948H617.764V86.047ZM706.717 34.375H664.529L664.529 0H789.529L789.529 34.375H747.342L747.234 125H706.717L706.717 34.375Z"
        fill="currentColor"
      />
    </Svg>
  </Anchor>
);
